<template>
  <base-modal>
    <img class="w-48" src="../../assets/images/transmaes_logo_big.svg" alt="">
  </base-modal>
</template>

<script>
  import BaseModal from '../base/BaseModal';

  export default {
    name: 'LoadingModal',
    components: {
      BaseModal,
    },
  };
</script>
